import * as React from 'react';
import { CONSTANTS } from '../../assets/UIConstants';
import { computed } from 'mobx';
import * as assert from 'assert';

interface Props {
    value?: number;
    valueFontSize?: number;
    unit?: string;
    unitFontSize?: number;
    color?: string;
    decimalPlaces?: number;
}

export class CurrentValue extends React.Component<Props, {}> {

    private style = {
        value: {
            fontSize: this.props.valueFontSize || 36,
            lineHeight: (this.props.valueFontSize || 36) + 'px',
            color: this.props.color || CONSTANTS.COLORS.DARKEST_GREY
        },
        unit: {
            fontSize: this.props.unitFontSize || 18,
            lineHeight: (this.props.valueFontSize || 36) + 'px',
            color: this.props.color || CONSTANTS.COLORS.DARKEST_GREY
        }
    };

    public static defaultProps: Partial<Props> = {
        value: 0.0,
        unit: '',
    };

    @computed private get value(): string {
        assert(undefined != this.props.value, 'CurrentValue#get value - this.props.value was undefined');
        let precision: number = 1;
        if (undefined != this.props.decimalPlaces) {
            precision = this.props.decimalPlaces;
        }
        return this.props.value!.toFixed(precision);
    }

    public render(): JSX.Element {
        return (
            <div>
                <span style={this.style.value}>
                    {this.value}
                </span>
                <span style={this.style.unit}>
                    {this.props.unit}
                </span>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/CurrentValue.tsx